<template>
  <div ref="editableField">
    <div class="d-flex align-items-center" v-if="!editing">
      <wo-status-etc v-if="type === 'priority'" field-name="priority" :value="text" class="me-2"></wo-status-etc>
      <template v-else>
        <h5 v-if="h5Wrap" class="me-2" :class="customClass"><span>{{ text }}</span></h5>
        <span v-else class="me-2" :class="customClass">{{ text }}</span>
      </template>

      <i ref="editBtn" class="ri-pencil-line cursor-pointer" v-if="editable"></i>
    </div>
    <template v-else>
      <b-form-input v-if="type === 'text'" v-model="editedText" @blur="saveChanges" @keyup.enter="saveChanges" class="form-control" />
      <textarea v-if="type === 'textarea'" :row="textareaRow" v-model="editedText" @blur="saveChanges" @keyup.enter="saveChanges" class="form-control"></textarea>
      <flat-pickr ref="flatpickr" v-if="type === 'datetime'" v-model="editedText" :config="flatpickrConfig" @input="saveChanges" :placeholder="this.$t('page.select-time')"
                  class="form-control" @onClose="pickrClose" @onOpen="pickrOpen"/>
      <customer-select v-if="type === 'customer'" @changed="setChangedValue" />
      <!--  紧急程度  -->
      <div v-if="type === 'type'" class="input-light">
        <Multiselect
            v-model="editedText"
            :close-on-select="true"
            :searchable="false"
            :create-option="false"
            :options="typeOptions"
            :can-deselect="false"
            :can-clear="false"
            @change="setChangedValue"
        />
      </div>
      <div v-if="type === 'priority'" class="input-light">
        <Multiselect
            v-model="editedText"
            :close-on-select="true"
            :searchable="false"
            :create-option="false"
            :options="priorityOptions"
            :can-deselect="false"
            :can-clear="false"
            @change="setChangedValue"
        />
      </div>
      <!--  multiselect  -->
      <div v-if="type === 'multiselect'" class="input-light">
        <Multiselect
            v-model="editedText"
            :close-on-select="multiselectCloseOnSelect"
            :searchable="multiselectSearchable"
            :create-option="multiselectCreateOption"
            :options="selectOptions"
            :value-prop="multiselectValueProp"
            :label="multiselectLabel"
            :can-clear="multiselectCanClear"
            :can-deselect="multiselectCanDeselect"
            @change="setChangedValue"
        />
      </div>
      <!--  设备选择  -->
      <div v-if="type === 'device'" class="input-light">
        <DeviceSelect
          :customer-id="customerId"
          :selected-device-root-sn="editedText"
          @changed="deviceChanged"
        ></DeviceSelect>
      </div>
    <!--   维保名称选择   -->
      <div v-if="type === 'maintain_name'">
        <maintenance-select
          v-model:value="editedText"
          :show-tips-when-err="false"
          @changed="maintainNameChange"
        ></maintenance-select>
      </div>
    </template>
  </div>

</template>

<script>
import CustomerSelect from "@/views/work-order/components/widgets/customer-select";
import WoStatusEtc from "@/views/work-order/components/widgets/wo-status-etc";
import { WorkOrderPriority,WO_TYPE,WO_TYPE_EQUIPMENT_QR_CODE } from "@/config/common";
import DeviceSelect from "@/views/widgets/device-select";
import _ from 'lodash';
import MaintenanceSelect from "@/views/widgets/maintenance-select.vue";
import { maintenanceItemList } from '@/utils/selectText';
import i18n from "@/i18n";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    CustomerSelect,
    WoStatusEtc,
    DeviceSelect,
    MaintenanceSelect,
    flatPickr
  },
  props: {
    value: {
      type: [String, Date, Number],
      default: ''
    },
    woData: {
      type: Object,
      default: ()=>{
        return {}
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    editable: {
      type: Boolean,
      default: true,
    },
    customClass: {
      type: String,
      default: '',
    },
    //----------------multiselect的配置------------------
    // 类型为multiselect时，需要传选项列表
    selectOptions: {
      type: Array,
      default: () => {
        return []
      }
    },
    multiselectCloseOnSelect: {
      type: Boolean,
      default: true
    },
    multiselectSearchable: {
      type: Boolean,
      default: false
    },
    multiselectCreateOption: {
      type: Boolean,
      default: false
    },
    multiselectValueProp: {
      type: String,
      default: 'value'
    },
    multiselectLabel: {
      type: String,
      default: 'label'
    },
    multiselectCanClear: {
      type: Boolean,
      default: false
    },
    multiselectCanDeselect: {
      type: Boolean,
      default: false
    },
    // 默认显示的值，当value在options中找不到值时，显示这个
    multiselectDefaultText: {
      type: String,
      default: ''
    },
    //-----------------multiselect的配置-------------------
    textareaRow: {
      type: Number,
      default: 4
    },
    // value的类型
    valueType: {
      type: String,
      default: ''
    },
    h5Wrap: {
      type: Boolean,
      default: true
    },
    //--------------------设备选择时，需要提供客户ID，用来查询可选的设备-------------------------
    customerId: {
      type: [Number, String],
      default: null
    },
    // ----------------显示的内容，如果有的话，非编辑状态显示这个值------------------
    displayText: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      WO_TYPE_EQUIPMENT_QR_CODE,
      priorityOptions: WorkOrderPriority,
      typeOptions: [],
      editing: false,
      editedText: this.formatValue(this.value),
      flatpickrConfig: {
        enableTime: false,
        dateFormat: "Y-m-d",
        time_24hr: false,
        inline: false,
        // wrap: false,
      },
      is_pickr_close:false,
    };
  },
  mounted() {
    document.addEventListener('click', this.clickMe);
    this.typeOptions = WO_TYPE.filter(item=>item.value != 5) //排除掉延保服务
    this.typeOptions.unshift({ value: `${WO_TYPE_EQUIPMENT_QR_CODE}`, label: i18n.global.t("page.work-order.type.QR-code") });//增加贴二维码
  },
  beforeUnmount() {
    document.removeEventListener('click', this.clickMe);
  },
  computed: {
    // 显示的值
    text() {
      if (this.displayText) {
        return this.displayText
      }
      if (this.type == 'multiselect') {
        const item = _.find(this.selectOptions, [this.multiselectValueProp, this.editedText]) ||
          _.find(this.selectOptions, [this.multiselectValueProp, this.editedText.toString()])
        if (!item) {
          return this.multiselectDefaultText
        }
        return item[this.multiselectLabel]
      }

      if (this.type === 'maintain_name') {
        const item = maintenanceItemList.find(item => item.value == this.value)
        if (!item) {
          return '-'
        }
        return item.label
      }
      if (this.type === 'type') {
        // if(WO_TYPE.find((v) => v.value == this.value).label=="设备保养"){
        //   const item = maintenanceItemList.find(item => item.value == this.woData.maintain_name)
        //   return item?WO_TYPE.find((v) => v.value == this.value).label +'-'+ item.label:WO_TYPE.find((v) => v.value == this.value).label

        // }else{
          let info = this.typeOptions.find((v) => v.value == this.value)
          return info&&info.label || "-"
        // }
      }

      return  this.value

    },
  },
  methods: {
    startEditing() {
      this.editing = true;
    },
    saveChanges(params) {
      if (params && typeof params === 'object') {
        this.$emit('complete', this.parseValue(this.editedText), params);
      } else {
        this.$emit('complete', this.parseValue(this.editedText));
      }
      this.editing = false;
    },
    setChangedValue (value) {
      if (value) {
        this.editedText = value
        this.saveChanges()
      }
    },
    deviceChanged(val) {
      if (val && val.root_sn != this.value) {
        this.editedText = val.root_sn
        this.$emit('complete', this.parseValue(this.editedText), { device_name: val.name, device_id: val.id });
        this.editing = false
      }
    },
    maintainNameChange(val) {
      if (val && val != this.value) {
        this.saveChanges()
      }
    },
    // 获取到的值处理
    formatValue(value) {
      if (this.valueType === 'int') {
        return parseInt(value)
      }
      return value
    },
    // 编辑完后返回的值处理
    parseValue(value) {
      if (this.type === 'datetime') {
        // return new Date(value);
        return value;
      } if (this.type == 'customer') {
        return value.id;
      } else {
        return value;
      }
    },
    clickMe(event) {
      const editBtnRef = this.$refs.editBtn
      if (editBtnRef) {
        if (editBtnRef.contains(event.target)) {
          this.startEditing()
          return;
        }
      }
      if (this.editing && !this.$refs.editableField.contains(event.target)) {
        if( !this.is_pickr_close ){ /* 规避日期控件切换时关闭 */
          this.editing = false
        }
      }
    },
    pickrOpen(){
      this.is_pickr_close = true
    },
    pickrClose(){
      this.is_pickr_close = false
    }
  },
};
</script>
<style>
.flatpickr-calendar.inline {
  min-width: 300px;
  z-index: 9999;
}
</style>
